<template>
  <v-form
    ref="newOrderForm"
    lazy-validation
    @submit.prevent="onSubmit"
  >
    <v-row>
      <v-col
        :lg="12"
        :md="12"
        :sm="12"
        :xs="12"
      >
        <OrderVehicleSelect v-model="form" />        
      </v-col>
    </v-row>    
    <v-btn
      small
      depressed
      color="primary"
      type="submit"
    >
      Continuar
    </v-btn>    
  </v-form>
</template>

<script>
  import OrderVehicleSelect from './OrderVehicleSelect.vue';
  import OrderService from '@/services/pedidos.service';

  export default {
    name: 'OrderSimpleVehicleForm',
    components: {    
      OrderVehicleSelect
    },
    props: {
      orderKind: {
        type: String,
        required: true
      }
    },
    data: () => ({
      form: {
        plate: null,
        transportId: null
      },
    }),
    methods: {
      onSubmit() {
        if (this.$refs.newOrderForm.validate()) {
          const vehicle = { plate: this.form.plate, transport_id: this.form.transportId };
          const payload = {  kind: this.orderKind, data: { vehicle: vehicle } };
        
          OrderService.create(payload).subscribe((response) => {
            this.$emit('orderCreate', { order: response });          
          });        
        }
      }
    },
  };
</script>